import React, { Component } from 'react';
import { PropTypes } from "prop-types";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { isEmpty } from "lodash";
import { withRouter } from 'react-router-dom';
import { fetchEmployeeSalaries, fetchUserSalaries } from '../../store/actions/salariesAction'
import { fetchServices, fetchFunctions  } from '../../store/actions/employeeAction'
import { fetchSalaryCats } from '../../store/actions/salaryCatsAction'
import { fetchProjects } from '../../store/actions/projectAction'
import { fetchEmployeeTimesheets,
    updateTimesheet,
    newTimesheet } from '../../store/actions/timesheetAction'
import { 
    fetchCurrentSession,
    newUserDemand,
    updateUserDemand,
    fetchUserDemands,
    fetchArticles,
} from '../../store/actions/demandAction'
import { fetchUserLoans, newLoanDemand, fetchUserLoanDemands, updateResaLoanUser, updateDemandLoanStatusUser, updateLoanDemand, deleteLoanDemand } from '../../store/actions/loanAction'
        
export default function(ComposedComponent) {

    class MustAuthBeEmployee extends Component {
        state = { 
            SALARIES: {}
        }
        componentWillMount() {
            if (!this.props.isAuthenticated || isEmpty(this.props.employee)) {
                this.props.history.push('/')
            } 
        }
        componentWillUpdate(nextProps) {
            if(!nextProps.isAuthenticated || isEmpty(this.props.employee)) {
                this.props.history.push('/')
            }
        }
        componentDidMount = () => {
            // console.log('================ REQUIRE AUTH EMPLOYEE ====================');
            // console.log("CDM");
            // console.log('====================================');
            if(this.props.isAuthenticated && !isEmpty(this.props.employee) ) {
                if(!this.props.STATE.sessions.fetched){
                    this.props.fetchCurrentSession()
                }
                // fetch employee salary list
                if(isEmpty(this.state.SALARIES)){
                   this.getSalaries()
                }
                if(isEmpty(this.props.SALARY_CATS)){
                    this.props.fetchSalaryCats()
                }
                if(isEmpty(this.props.SERVICES)){
                    this.props.fetchServices()
                }
                if(isEmpty(this.props.FUNCTIONS)){
                    this.props.fetchFunctions()
                }
                if(isEmpty(this.props.PROJECTS)){
                    this.props.fetchProjects()
                }
                if(isEmpty(this.props.TIMESHEETS)){
                    this.props.fetchEmployeeTimesheets()
                }
            }
        }
        getSalaries = async () => {
            const list = await this.props.fetchUserSalaries(this.props.employee.employee_id)
            // console.log('=================getSalaries===================');
            // console.log({list});
            // console.log('====================================');
            this.setState({
                SALARIES: list
            })
        }
        render() {
            // console.log('====================================');
            // console.log(this.state.SALARIES);
            // console.log('====================================');
            
            return (
                <ComposedComponent {...this.props} SALARIES={this.state.SALARIES} />
            );
        }
    }
    
    MustAuthBeEmployee.propTypes = {
        isAuthenticated : PropTypes.bool.isRequired
    }

    function mapStateToProps(state){
        return {
            isAuthenticated : state.auth.isAuthenticated,
            isSuper: state.auth.isSuperAdmin,
            employee: state.auth.employee,
            STATE: state.request,
            // SALARIES: state.salaries,
            SALARY_CATS: state.salary_cats,
            SERVICES: state.services,
            FUNCTIONS: state.functions,
            PROJECTS: state.projects,
            TIMESHEETS: state.timesheets,
            CURRENT_SESSION: state.sessions.CURRENT,
            ARTICLES: state.articles,
            DEMANDS: state.demands,
            LOANS: state.loans.USER,
            LOAN_DEMANDS: state.loanDemands.USER,
        }
    }
    
    function mapDispatchToProps(dispatch){
        return bindActionCreators({
            fetchEmployeeSalaries,
            fetchServices,
            fetchFunctions, 
            fetchSalaryCats, 
            fetchUserSalaries,
            fetchProjects, 
            fetchEmployeeTimesheets,
            newTimesheet,
            updateTimesheet, 
            fetchCurrentSession,
            newUserDemand,
            updateUserDemand,
            fetchUserDemands,
            fetchArticles,
            fetchUserLoans,
            newLoanDemand,
            fetchUserLoanDemands,
            updateResaLoanUser,
            updateDemandLoanStatusUser,
            updateLoanDemand,
            deleteLoanDemand
        }, dispatch)
    }

    return connect(mapStateToProps, mapDispatchToProps)(withRouter(MustAuthBeEmployee))
}